module.exports = __webpack_public_path__ + "static/assets/bf42b45bc4320f3f21fdaf3e0e12ca41.svg";